// One corner-radius scale for the dashboard's surfaces.
//
// These had drifted to eight different values — the generic panel was 8, the
// newer sections 12, the curriculum panel 14, the leaderboard and activity
// rails 26 — so panels sitting side by side on the same page visibly disagreed
// about how round a card is.
//
// Pick by the role of the surface, not by how big it happens to be:
//   panel — anything that reads as a card on the page background
//   chip  — a block nested INSIDE a panel (icon chips, inner rows, thumbnails)
//   badge — small text tags
//   pill  — fully rounded: buttons, progress tracks, capsules
//
// Circles stay half-of-their-own-size at the call site; there's no token for
// them because the value depends on the element's dimensions.

export const radii = {
  panel: 12,
  chip: 10,
  badge: 6,
  pill: 999,
} as const;

/**
 * Radius for a layer drawn INSIDE a panel's border — a background fill or an
 * accent rail. One less than the panel so the fill's corner sits flush inside
 * the border rather than poking through it.
 */
export const insetRadius = (r: number = radii.panel) => r - 1;
